export default __webpack_public_path__ + "static/media/ERP-Illustration2.534c9d80.png";